/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useMemo, useState } from 'react';
import Chart from 'react-apexcharts';
import { useSelector } from 'react-redux';
import { useMediaQuery } from '@mui/material';

import getPolarAreaConfig from './PolarAreaConfig';
import LegendItem from '../../legend/LegendItem';
import useChartColors from '../../../../hooks/useChartColors';
import withEmptyChart from '../../../../hoc/withEmptyChart';

import scss from './PolarArea.module.scss';

function PolarAreaChart({ data, dataKey }) {
  const theme = useSelector((state) => state.global.theme);
  const colors = useChartColors();
  const isMobile = useMediaQuery('(max-width: 600px)');

  const CHART_HEIGHT = isMobile ? 280 : 400;

  const [chartData, setChartData] = useState([]);

  const activeDomains = useMemo(() => chartData.filter((item) => item.active), [chartData]);

  const handleToggleDomain = (domain) => {
    setChartData((prevData) =>
      prevData.map((item) => (item.domain === domain ? { ...item, active: !item.active } : item)),
    );
  };

  const chartConfig = getPolarAreaConfig(activeDomains, theme);

  useEffect(() => {
    if (data.length) {
      setChartData(
        data
          .map((el, i) => ({
            x: el.label || el.domain,
            y: el[dataKey].score,
            inFocus: el.inFocus,
            myCompany: el.myCompany,
            color: colors[i % colors.length],
            active: true,
            domain: el.domain,
            companyName: el.companyName,
          }))
          .sort((a, b) => b.y - a.y),
      );
    }
  }, [data, colors, dataKey]);

  const handleContextMenu = (event) => {
    event.preventDefault();
  };

  return (
    <div className={scss.chart}>
      <div className={scss.chartContainer}>
        <Chart
          series={chartConfig.series}
          options={chartConfig.options}
          type='polarArea'
          height={CHART_HEIGHT}
          onContextMenu={handleContextMenu}
        />
      </div>
      <div className={scss.legendsContainer}>
        {chartData.map(({ x, active, inFocus, color, domain, myCompany }, i) => (
          <LegendItem
            key={'PolarArea-legend-' + i}
            title={x}
            isActive={active}
            inFocus={inFocus}
            color={color}
            domain={domain}
            myCompany={myCompany}
            onClick={handleToggleDomain}
          />
        ))}
      </div>
    </div>
  );
}

export default withEmptyChart(PolarAreaChart);
